import { Expand } from '@/helpers/expand-type';
import { Merge } from '@/helpers/merge-type';
import { gql } from '@/modes/waterSupplier/gql';
import { ResultOf } from 'gql.tada';

export const GET_TEST_REPORT = gql(`
  query GetTestReport($where: JSON) {
    backflowTests(where: $where) {
      jobId
      waterSupplier {
        profileId
        rpCheck2Type
        profile {
          name
        }
      }
      waterSupplierStatus
      testingCompanyName
      testerName
      dateTested
      finalResult
      #     flags
      job {
        id
        address {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        formData
        attachments {
          id
          contentType
          url
          thumb(size: 500)
          profile {
            id
            name
          }
          created
        }
        siteContact {
          name
          address {
            id
            street1
            street2
            city
            state
            zip
            zipExt
          }
          email
          phone
        }
        comments {
          id
          type
          visibility
          comment
          profile {
            id
            name
          }
          created
        }
        statusChanges {
          id
          fromStatus
          toStatus
          profile {
            id
            name
          }
          created
        }
        #       submitted
        #       customer
        #       testing company
        #       tester
      }
      originalBackflowAssembly {
        id
        modelId
        model {
          id
          name
          backflowAssemblyMake {
            name
          }
        }
        serialNumber
        size
        type
        location
        installDate
      }
      backflowAssembly {
        id
        modelId
        model {
          id
          name
          backflowAssemblyMake {
            name
          }
        }
        serialNumber
        size
        type
        location
        installDate
        waterService {
          id
          siteNumber
          meterNumber
          pin
          serviceAddresses(
            where: { active: true }
            limit: null
            required: true
          ) {
            customer(where: { status: 1 }, required: true) {
              id
              profile {
                name
              }
            }
          }
        }
      }
    }
  }
`);

export const APPROVE_BACKLOW_TEST = gql(`
  mutation ApproveBackflowTest($jobId: ID!) {
    approveBackflowTest(jobId: $jobId) {
      jobId
      waterSupplierStatus
    }
  }
`);

export type BackflowTest = ResultOf<
  typeof GET_TEST_REPORT
>['backflowTests'][number];
export type AssemblyInfo = NonNullable<BackflowTest['backflowAssembly']>;
export type Job = NonNullable<BackflowTest['job']>;
